import { SWRConfiguration } from 'swr'
import { SwrUseQueryOutput, useQuery } from '../use-query'
import { getEmptyAutocompleteQuery } from './graphql/getEmptyAutocompleteQuery'

type EmptyAutocompleteCategory = {
    id?: string
    name?: string
    url?: string
}

type EmptyAutocompleteProduct = {
    sku?: string
    name?: string
    url?: string
    small_image?: string
    price?: {
        regular_price?: {
            value?: number
            currency?: string
        }
        final_price?: {
            value?: number
            currency?: string
        }
        discount?: {
            amount_off?: number
            percent_off?: number
        }
    }
}

type EmptyAutocompleteResponse = {
    getEmptyAutocomplete?: {
        categories?: EmptyAutocompleteCategory[]
        products?: EmptyAutocompleteProduct[]
    }
}

type UseEmptyAutocompleteResult = {
    emptyAutocomplete?: EmptyAutocompleteResponse['getEmptyAutocomplete']
} & Omit<SwrUseQueryOutput<EmptyAutocompleteResponse>, 'data'>

export const useEmptyAutocomplete = (
    swrOptions: SWRConfiguration = {},
    isActive = true
): UseEmptyAutocompleteResult => {
    const { data, ...rest } = useQuery<undefined, EmptyAutocompleteResponse>(
        isActive ? getEmptyAutocompleteQuery : null,
        undefined,
        swrOptions
    )
    return {
        emptyAutocomplete: data?.data?.getEmptyAutocomplete,
        ...rest
    }
}
